module.exports = __webpack_public_path__ + "static/media/PrintYellowIcon.e7103461.svg";